import React from 'react'
import { throttle } from 'throttle-debounce'

/**
 * This uses code from https://github.com/streamich/react-use/ but adds { passive: true } to touch and wheel event listeners
 * to meet Calibre standards. See https://developer.chrome.com/docs/lighthouse/best-practices/uses-passive-event-listeners/
 */
export function useIdle(ms = 1000 * 60) {
  const [idle, setIdle] = React.useState(false)

  React.useEffect(() => {
    let timeoutId: NodeJS.Timeout | undefined = undefined

    const handleTimeout = () => {
      setIdle(true)
    }

    const handleEvent = throttle(500, () => {
      setIdle(false)

      globalThis.clearTimeout(timeoutId)
      timeoutId = globalThis.setTimeout(handleTimeout, ms)
    })

    const handleVisibilityChange = () => {
      if (!globalThis.document?.hidden) {
        handleEvent()
      }
    }

    timeoutId = globalThis.setTimeout(handleTimeout, ms)

    globalThis.addEventListener('mousemove', handleEvent)
    globalThis.addEventListener('mousedown', handleEvent)
    globalThis.addEventListener('resize', handleEvent)
    globalThis.addEventListener('keydown', handleEvent)
    globalThis.addEventListener('touchstart', handleEvent, { passive: true })
    globalThis.addEventListener('wheel', handleEvent, { passive: true })
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      globalThis.removeEventListener('mousemove', handleEvent)
      globalThis.removeEventListener('mousedown', handleEvent)
      globalThis.removeEventListener('resize', handleEvent)
      globalThis.removeEventListener('keydown', handleEvent)
      globalThis.removeEventListener('touchstart', handleEvent)
      globalThis.removeEventListener('wheel', handleEvent)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      globalThis.clearTimeout(timeoutId)
    }
  }, [ms])

  return idle
}
